export const getContactsUrl = () => '/business/contacts';

export const getContactUrl = (id: number) => `/business/contacts/${id}`;

export const getNotesUrl = (id: number) => `/business/contacts/${id}/notes`;

export const getNoteUrl = (contactId: number, id: number) => `/business/contacts/${contactId}/notes/${id}`;
